import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { Observable } from 'rxjs';
import { ICameraItem, ICameraParams, ICameraPayload } from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class CameraApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/cameras';

  getAllCameras(filter?: ICameraParams): Observable<ICameraItem[]> {
    return this.http.get(this.apiUrl, filter);
  }

  setCamera(payload: ICameraPayload): Observable<unknown> {
    return this.http.post(this.apiUrl, payload);
  }

  getCameraById(id: string): Observable<ICameraItem> {
    return this.http.get(this.apiUrl + '/' + id);
  }

  updateCameraById(id: string, payload: ICameraPayload): Observable<unknown> {
    return this.http.put(this.apiUrl + '/' + id, payload);
  }

  deleteCamera(id: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + id);
  }
}
